// extracted by mini-css-extract-plugin
export default {"zr-configurator-button":"ConfiguratorButton_zr-configurator-button__Jj-cF"};